import React from "react";
import { useLocation } from "react-router-dom";
import { trackCTA } from "../../utils/analytics";
import { useSiteInfo } from "../../contexts/SiteInfoContext";
import routePaths from "../../routes/routePaths";
import { useTranslation } from "react-i18next";

// Các path muốn ẩn button Zalo
const hidePaths = [routePaths.user, routePaths.admin, routePaths.testList];

const FloatingZaloButton = () => {
  const { siteInfo, loading } = useSiteInfo();
  const { pathname } = useLocation();
  const { t } = useTranslation();

  if (loading || !siteInfo) return null;
  if (hidePaths.some((path) => pathname.startsWith(path))) return null;

  const handleClick = () => {
    trackCTA("Zalo Button", "Floating");
  };

  return (
    <a
      href={siteInfo.zalo}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
      className="
        fixed bottom-7 right-5 z-[99]
        bg-primary text-textButton font-extrabold
        shadow flex items-center gap-2
        px-5 py-3 rounded-full
        border-2 border-primary
        transition-all duration-300
        hover:bg-primary/90 hover:shadow-lg
        active:scale-95
        animate-floatBtn
      "
      aria-label={t("zaloBtn.ariaLabel")}
    >
      <span className="bg-card rounded-full p-1 mr-1 flex items-center justify-center">
        {/* SVG Zalo đúng chuẩn */}
        <svg viewBox="0 0 40 40" className="w-6 h-6" xmlns="http://www.w3.org/2000/svg">
          <circle cx="20" cy="20" r="20" fill="#018fe7"/>
          <text x="20" y="27" textAnchor="middle" fontSize="17" fontWeight="bold" fill="#fff" fontFamily="Arial">Z</text>
        </svg>
      </span>
      <span className="hidden sm:inline">{t("zaloBtn.label")}</span>
    </a>
  );
};

export default FloatingZaloButton;
